<div>
  <img id="barcode" />
  <div class="barcode-text">{{ barcode }}</div>
</div>